import axios from "axios";
import config from "../../config/config";
import { PurchasedPackage, AvailablePackage, PackageModuleInfo } from "./packages.interfaces";

const API_URL = `${config.apiBaseUrl}/students/packages`;

const axiosClient = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: config.defaultTimeout,
});

axiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const apiGetPurchasedPackages = async (): Promise<PurchasedPackage[]> => {
  try {
    const response = await axiosClient.get<PurchasedPackage[]>("/purchased");
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Axios error during get purchased packages:", error.message);
    } else {
      console.error("Unexpected error during get purchased packages:", error);
    }
    throw error;
  }
};

export const apiGetAvailablePackages = async (): Promise<AvailablePackage[]> => {
  try {
    const response = await axiosClient.get<AvailablePackage[]>("/available");
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Axios error during get available packages:", error.message);
    } else {
      console.error("Unexpected error during get available packages:", error);
    }
    throw error;
  }
};

export const apiGetPackageModules = async (packageId: string): Promise<PackageModuleInfo[]> => {
  try {
    const response = await axiosClient.get<PackageModuleInfo[]>(`${packageId}/modules`);
    return response.data;
  } catch (error) {
    console.error("Error fetching package modules:", error);
    throw error;
  }
}; 